var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1018_7552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5574 8.83724L4.65039 7.44189V17.7521C4.65039 18.223 5.03209 18.6047 5.50295 18.6047H19.1467C19.6175 18.6047 19.9992 18.223 19.9992 17.7521V13.9535L12.5574 8.83724Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5574 0H5.50295C5.03209 0 4.65039 0.381701 4.65039 0.852556V4.65116L12.5574 9.30233L16.7434 10.6977L19.9992 9.30233V4.65116L12.5574 0Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65039 4.65112H12.5574V9.30229H4.65039V4.65112Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.3095 3.72095H4.65039V15.3489H10.3095C10.7797 15.3473 11.1605 14.9665 11.162 14.4963V4.5735C11.1605 4.10329 10.7797 3.72248 10.3095 3.72095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.84435 4.18604H4.65039V15.8139H9.84435C10.3146 15.8124 10.6954 15.4316 10.6969 14.9614V5.03859C10.6954 4.56837 10.3146 4.18756 9.84435 4.18604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.84435 4.18604H4.65039V14.8837H9.84435C10.3146 14.8822 10.6954 14.5014 10.6969 14.0312V5.03859C10.6954 4.56837 10.3146 4.18756 9.84435 4.18604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.37923 4.18604H4.65039V14.8837H9.37923C9.84945 14.8822 10.2303 14.5014 10.2318 14.0312V5.03859C10.2303 4.56837 9.84945 4.18756 9.37923 4.18604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.852556 4.18604H9.37999C9.85085 4.18604 10.2326 4.56774 10.2326 5.03859V13.566C10.2326 14.0369 9.85085 14.4186 9.37999 14.4186H0.852556C0.381701 14.4186 0 14.0369 0 13.566V5.03859C0 4.56774 0.381701 4.18604 0.852556 4.18604Z",
    fill: "url(#paint0_linear_1018_7552)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64062 12.0736L4.43411 9.29449L2.79086 6.53076H4.11272L5.00946 8.2982C5.09226 8.46611 5.149 8.59076 5.1797 8.67308H5.19132C5.25024 8.53913 5.31225 8.40905 5.37737 8.28285L6.33597 6.5317H7.54946L5.86434 9.27914L7.59226 12.0735H6.3011L5.26528 10.1336C5.21649 10.051 5.17509 9.96432 5.14156 9.87449H5.12622C5.09587 9.96249 5.05561 10.0468 5.00621 10.1257L3.9397 12.0736H2.64062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1479 0H12.5586V4.65116H20.0005V0.852556C20.0005 0.381701 19.6188 0 19.1479 0Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5586 9.30225H20.0005V13.9534H12.5586V9.30225Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1018_7552",
    x1: 1.7776,
    y1: 3.51986,
    x2: 8.45496,
    y2: 15.0848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1018_7552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18.6047,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.2e5f53e2d519afd736f676cbfba4b769.svg";
export { ForwardRef as ReactComponent };